import AnalyticsEvents from '~/analytics';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

interface UseSMTDiscardModalParams {
  patientId: string;
}

interface UseSMTDiscardModalReturn {
  handleDiscardModalBackClick: () => void;
  handleDiscardModalConfirm: () => void;
  handleDiscardModalDismiss: () => void;
  handleDiscardModalView: () => void;
}

export const useSMTDiscardModal = ({
  patientId,
}: UseSMTDiscardModalParams): UseSMTDiscardModalReturn => {
  const { trackEvent } = useAnalytics();

  const handleDiscardModalView = () => {
    trackEvent(AnalyticsEvents.discardEntryChangesModalView, {
      patientId,
      source: AnalyticsSourceValues.SMT_TAB,
    });
  };

  const handleDiscardModalDismiss = () => {
    trackEvent(AnalyticsEvents.discardEntryChangesDismissClick, {
      patientId,
      source: AnalyticsSourceValues.SMT_TAB,
    });
  };

  const handleDiscardModalBackClick = () => {
    trackEvent(AnalyticsEvents.discardEntryChangesBackClick, {
      patientId,
      source: AnalyticsSourceValues.SMT_TAB,
    });
  };

  const handleDiscardModalConfirm = () => {
    trackEvent(AnalyticsEvents.discardEntryChangesConfirmClick, {
      patientId,
      source: AnalyticsSourceValues.SMT_TAB,
    });
  };

  return {
    handleDiscardModalBackClick,
    handleDiscardModalConfirm,
    handleDiscardModalDismiss,
    handleDiscardModalView,
  };
};
